import React from 'react';
import { Card, Typography } from 'antd';

const { Text } = Typography;

interface CurrentFilesDisplayProps {
  mrpFilename?: string | null;
  bomFilename?: string | null;
}

const CurrentFilesDisplay: React.FC<CurrentFilesDisplayProps> = ({ mrpFilename, bomFilename }) => {
  return (
    <Card title="Aktuell verwendete Dateien" style={{ marginTop: 24, marginBottom: 24 }}>
      <Text><strong>MRP-Parameter Datei:</strong> {mrpFilename || 'Nicht geladen'}</Text><br />
      <Text><strong>Stückliste Datei:</strong> {bomFilename || 'Nicht geladen'}</Text>
    </Card>
  );
};

export default CurrentFilesDisplay;